export default () => ({
  specialDesigns: [
    {
      slug: 'eendracht',
      url: 'psv',
      startDate: '2025-08-26T08:00:00.000Z', // YYYY-MM-DD
      membershipTypeReference: 'men-originals-membership',
      ended: true
    },
    {
      slug: 'heya',
      url: 'fcdb',
      startDate: '2025-09-16T08:00:00.000Z', // This is UTC time
      membershipTypeReference: 'men-originals-membership',
      ended: false
    }
  ]
})
